import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { auth as authApi } from "../services/auth";
import "../components/AuthForm.css";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    await authApi.forgotPassword(email);
    setSubmitting(false);
    setDone(true);
  }

  return (
    <section className="auth-shell container">
      <div className="auth-card card">
        <h1>Reset your password</h1>
        <p className="auth-card__sub">
          Enter the email associated with your account. We'll send you a reset link.
        </p>
        {done ? (
          <div className="form__success">
            If an account with that email exists, you'll receive a reset link shortly. Check your inbox.
          </div>
        ) : (
          <form className="form" onSubmit={onSubmit}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" className="btn btn--primary" disabled={submitting}>
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <p className="form__footer">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </section>
  );
}
